<template>
  <div v-if="permission && permission.version === '5'" class="all-employer-board-page">
    <b-container fluid class="page_content">
      <div class="pg_toolbar job-board-toolbar">
        <div class="toolbar-left data-row">
          <div class="toolbar-title ace_sec_txt">
            <span class="ic_container">
                <span class="ic ico-employer"></span>
            </span>
            <h1
              class="head_txt module_type_name ace_sec_hd"
              role="heading"
              aria-level="1">
                {{ $t('allEmployers') }} [{{total}}]
            </h1>

          </div>
        </div>
        <div class="toolbar-right">
          <!--
          <div class="out-of-total-item ace_sec_txt">
            <div>{{ total }} {{ $t('employers').toLowerCase() }}</div>
          </div>
          -->
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="allEmployerSizeDropdown" :text="''+size" :options="sizeOptions" :aria-label="$t('numberOfItem')">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
                <b-dropdown-item @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="pageNumber <= 1" @click="prevPage" @keydown.enter="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{pageNumber}}</span>
            <button type="button" class="btn btn_trans" :disabled="(from + size) >= total" @click="nextPage" @keydown.enter="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" :placeholder="$t('typeToNarrowResults')" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="$t('typeToNarrowResults')">
            <button class="btn btn_srh" @click="searchButtonClicked" :aria-label="$t('goAria')">
              <span class="ic_srh ic_search"></span>
            </button>
            <button id="allEmployerSortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec">
              <span class="ic2_sort2 sort-by-icon"></span>
              <span class="txt_srt">{{ $t('sort') }}</span>
            </button>
            <div id="allEmployerSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="allEmployerSortByDropDown" :show.sync="showSortByDropDown" container="allEmployerSortPopup" triggers="blur">
            <div class="header-content-row">
              <span class="title">{{ $t('sortBy') }}</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="'all-employer-' + sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="'all-employer-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
          </b-popover>
        </div>
      </div>

      <div class="job-board-body">
        <div class="job-board-list">
          <b-row class="explore_entity_result">
            <div cols="12" class="datatable">
              <b-row class="search_result_container">
                <b-col cols="12">
                  <b-list-group>
                    <template v-if="results.length === 0">
                      <div class="msg_no_result ace_sec_txt">
                        {{ $t('noResult') }}
                      </div>
                    </template>
                    <template v-else>
                      <b-list-group-item class="flex-column align-items-start result_row" v-for="(result, index) in results" :key="result.uuid" :class="{ 'is-selected': result.uuid === selectedEmployerUuid }" @click="selectEmployer(result)">
                        <div class="result_block">
                          <div class="job-card-main">
                            <div class="job-header-row">
                              <div class="title_icon" v-if="result.logo">
                                <img :src="result.logo" width="28" height="28" alt=""/>
                              </div>
                              <div class="title ace_sec_txt" :id="'all_employer_entity_' + index">{{ result.title }}</div>
                            </div>
                            <div class="job-meta-grid">
                              <div class="job-meta-item job-jobs-item">
                                <div class="icon_container">
                                  <span class="icon-briefcase"></span>
                                </div>
                                <div class="ace_sec_txt">
                                  {{ jobPostedCount(result) }} {{ $t('jobs') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-list-group-item>
                    </template>
                  </b-list-group>
                </b-col>
              </b-row>
            </div>
          </b-row>
        </div>
        <div class="job-board-details">
          <employer-details v-if="selectedEmployerUuid" :key="selectedEmployerUuid" :uuid="selectedEmployerUuid" :embedded="true" :job-posted="selectedEmployerJobPosted"></employer-details>
          <div v-else class="job-details-empty ace_sec_txt">
            {{ $t('selectEmployerToViewDetails') }}
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import EmployerDetails from '../../job/components/EmployerDetails'
  import '../../../assets/module/sass/discover/discover.scss'

  export default {
    name: 'manageAllEmployers',
    components: {
      EmployerDetails
    },
    data () {
      return {
        results: [],
        total: 0,
        from: 0,
        pageNumber: 1,
        size: 10,
        sizeOptions: [10, 50, 100],
        searchTerms: '',
        selectedSortName: 'Title',
        showSortByDropDown: false,
        selectedEmployerUuid: null,
        sorts: [
          {name: 'Title', labelKey: 'title'},
          {name: 'Jobs', labelKey: 'jobs'}
        ]
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      }),
      selectedEmployerJobPosted () {
        let selected = this.results.find((item) => {
          return item.uuid === this.selectedEmployerUuid
        })
        if (!selected || selected.jobPosted === undefined || selected.jobPosted === null || selected.jobPosted === '') {
          return 0
        }
        return selected.jobPosted
      }
    },
    mounted () {
      this.loadPermission().then(() => {
        this.loadEmployers()
      })
    },
    methods: {
      ...mapActions([
        'loadPermission',
        'searchEmployers'
      ]),
      loadEmployers () {
        let page = this.pageNumber - 1
        if (page < 0) {
          page = 0
        }
        this.searchEmployers({
          page: page,
          count: this.size,
          title: this.searchTerms
        }).then((result) => {
          if (result && result.content) {
            this.results = result.content
            this.total = result.totalElements || 0
            this.pageNumber = (result.number || 0) + 1
            this.from = (this.pageNumber - 1) * this.size
            this.sortCurrentPage()
          } else {
            this.results = []
            this.total = 0
          }
          this.syncSelectedEmployer()
        })
      },
      sortCurrentPage () {
        if (!this.results || this.results.length === 0) {
          return
        }
        if (this.selectedSortName === 'Jobs') {
          this.results.sort((a, b) => {
            return this.jobPostedCount(b) - this.jobPostedCount(a)
          })
        } else {
          this.results.sort((a, b) => {
            return (a.title || '').localeCompare(b.title || '')
          })
        }
      },
      jobPostedCount (result) {
        if (!result || result.jobPosted === undefined || result.jobPosted === null || result.jobPosted === '') {
          return 0
        }
        return result.jobPosted
      },
      syncSelectedEmployer () {
        if (!this.results.length) {
          this.selectedEmployerUuid = null
          return
        }
        let stillVisible = this.results.some((item) => {
          return item.uuid === this.selectedEmployerUuid
        })
        if (!stillVisible) {
          this.selectedEmployerUuid = this.results[0].uuid
        }
      },
      selectEmployer (result) {
        if (result && result.uuid) {
          this.selectedEmployerUuid = result.uuid
        }
      },
      searchButtonClicked () {
        this.from = 0
        this.pageNumber = 1
        this.loadEmployers()
      },
      toggleSortByDropDown () {
        this.showSortByDropDown = !this.showSortByDropDown
      },
      sortOkClicked () {
        this.showSortByDropDown = false
        this.sortCurrentPage()
      },
      changeSize (option) {
        this.size = option
        this.from = 0
        this.pageNumber = 1
        this.loadEmployers()
      },
      prevPage () {
        if (this.pageNumber > 1) {
          this.pageNumber = this.pageNumber - 1
          this.from = (this.pageNumber - 1) * this.size
          this.loadEmployers()
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.pageNumber = this.pageNumber + 1
          this.from = (this.pageNumber - 1) * this.size
          this.loadEmployers()
        }
      }
    }
  }
</script>

<style scoped>
  .job-card-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .job-header-row {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    min-width: 0;
  }

  .datatable .result_block .job-meta-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
    row-gap: 8px;
    width: 100%;
    min-width: 0;
  }


  .datatable .result_block .job-status-item,
  .datatable .result_block .job-jobs-item {
    min-width: 0;
  }

  .datatable .result_block .job-status-item .ace_sec_txt,
  .datatable .result_block .job-jobs-item .ace_sec_txt {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }





  .datatable .result_block .title {
    font-weight: 500;
    font-size: 16px;
    float: none;
    margin: 0;
    padding: 0;
    width: auto;
    max-width: 100%;
    overflow: visible;
    white-space: normal;
    color: #4a4a4a;
  }

  .datatable .result_block .job-header-row > .title {
    flex: 1 1 auto;
    min-width: 0;
  }

  .datatable .result_row {
    position: relative;
    padding: 16px 18px;
    margin: 0 20px 12px 16px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d4d4d4 !important;
    border-radius: 16px !important;
  }

  .datatable .result_row:hover,
  .datatable .result_row:focus {
    background: #fff;
  }

  .datatable .result_row + .result_row {
    border-top-width: 1px !important;
  }

  .datatable .result_row.is-selected,
  .datatable .result_row.is-selected:hover,
  .datatable .result_row.is-selected:focus {
    background: #f3f3f3;
  }

  .datatable .result_row.is-selected:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    width: 14px;
    height: 14px;
    background: #f3f3f3;
    border-top: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    transform: translateY(-50%) rotate(45deg);
  }

  .job-board-body {
    display: flex;
    align-items: stretch;
    width: 100%;
    min-height: 0;
  }

  .job-board-list {
    width: 33%;
    min-width: 0;
    overflow: auto;
    max-height: calc(100vh - 180px);
    min-height: 480px;
  }

  .job-board-details {
    width: 67%;
    min-width: 0;
    overflow: auto;
    max-height: calc(100vh - 180px);
    min-height: 480px;
    border-left: 1px solid #ebebeb;
    background: #fff;
  }

  .job-details-empty {
    padding: 24px 16px;
  }

  .job-board-list .search_result_container {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .job-board-list .search_result_container > [class*="col"] {
    padding-left: 0;
    padding-right: 0;
  }

  .job-board-list .list-group {
    margin-bottom: 0;
    padding-top: 12px;
    padding-bottom: 12px;
    background: transparent;
    border: none;
  }

  .datatable {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }

  .explore_entity_result {
    margin-left: 0;
    margin-right: 0;
  }

  .search_result_container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .datatable .result_row .result_block {
    width: 100%;
    max-width: 100%;
    float: none;
    margin-left: 0;
  }

  .job-board-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 27px;
    border-bottom: 1px solid #ebebeb;
    background: #fff;
    flex-wrap: nowrap;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  .toolbar-right .out-of-total-item {
    margin-right: 10px;
  }



  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }


  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .toolbar-right .sort-by {
    margin-left: 8px;
  }

  .msg_no_result {
    padding: 24px 16px;
  }
</style>

<style>
  .all-employer-board-page .job-board-details .page_content {
    padding: 28px 16px 24px;
    margin-top: 0;
    margin-left: 0;
  }

  .all-employer-board-page .job-board-details .container-fluid {
    padding-top: 0;
  }
  .all-employer-board-page .sort_by_popover .popover {
    transform: none !important;
    top: 2px !important;
    left: auto !important;
    right: 0 !important;
    margin: 0px !important;
    min-width: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/app/search/components/ManageAllEmployers.vue